import React, { useMemo, useState } from "react";
import { Icon } from "@mui/material";
import StarOutlinedIcon from '@mui/icons-material/StarOutlined';

const Rate = ({ count, rating, color, onRating }) => {
  const [hoverRating, setHoverRating] = useState(0);

  const getColor = index => {
    if (hoverRating >= index) {
      return color.filled;
    } else if (!hoverRating && rating >= index) {
      return color.filled;
    }

    return color.unfilled;
  };

  const starRating = useMemo(() => {
    return Array(count)
      .fill(0)
      .map((_, i) => i + 1)
      .map(idx => (
        <StarOutlinedIcon
          key={idx}
          onClick={() => onRating(idx)}
          sx={{
            color: getColor(idx),
            fontSize: 40,
            margin: "0 10px"
          }}
          onMouseEnter={() => setHoverRating(idx)}
          onMouseLeave={() => setHoverRating(0)}
        />
      ));
  }, [count, rating, hoverRating]);

  return <>{starRating}</>;
};

Rate.defaultProps = {
  count: 5,
  rating: 0,
  color: {
    filled: "#f5eb3b",
    unfilled: "#DCDCDC"
  }
};

export default Rate;
